import React, { useEffect, useState } from 'react';

import { getPendingRequests, subscribeRequests } from '../../services/requestActivity';
import './styles.css';

// So aparece quando a resposta demora: evita piscar nas requisicoes rapidas.
const SHOW_AFTER_MS = 300;

export default function RequestProgress() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timer = null;
    const update = (count) => {
      if (count > 0) {
        if (!timer) timer = setTimeout(() => setVisible(true), SHOW_AFTER_MS);
        return;
      }
      clearTimeout(timer);
      timer = null;
      setVisible(false);
    };
    update(getPendingRequests());
    const unsubscribe = subscribeRequests(update);
    return () => {
      clearTimeout(timer);
      unsubscribe();
    };
  }, []);

  return (
    <div
      className={`request-progress${visible ? ' is-visible' : ''}`}
      role="progressbar"
      aria-label="Carregando"
      aria-hidden={!visible}
    >
      <span className="request-progress-bar" />
    </div>
  );
}
